import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
    name: "DateStringFormat"
})
export class DateStringFormatPipe implements PipeTransform {
    // value format should be HH:mm:ss
    // return result will be hh:mm PM
    transform(value: string) {
        if (value != null && value != "") {
            let h = +value.split(':')[0];
            let m = value.split(':')[1];
            let hour = (h == 0) ? '12' : h;
            let time = ' AM';
            if (h >= 12) {
                hour = (h == 12) ? h : h - 12;
                time = ' PM';
            }
            if ((h>12 && h - 12 < 10)|| (h<10 && h != 0))
                hour = '0' + hour;
            return hour + ':' + m + time;
            //return (h > 12) ? (h - 12) : h + ':' + m + (h > 12) ? ' PM' : ' AM';
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/date-string-format.pipe.ts